'use strict';

import HttpServiceInterface from './interfaces/ihttp-service';
import RequestModel from '../models/request';
import urlTemplate from 'url-template';
import 'whatwg-fetch';

/**
 * @property {Object} headers - HTTP Headers to be sent on all requests. Defaults to adding:
 1. x-session-api-key
 2. x-request-id
 */
export default class BrowserHttpService extends HttpServiceInterface {
  /**
   * @param {String} sessionId - session id to be used with `x-session-api-key` header
   * @param {String} requestId - otherwise called transaction id, helpful in debugging/tracing request life cycles
   */
  constructor(sessionId, requestId) {
    super();
    this.headers = {};
    Object.assign(this.headers, {
      'x-session-id': sessionId,
      'x-request-id': requestId || new RequestModel().id
    });
  }

  /**
   * @desc HTTP 'GET'
   * @param {String} url
   * @param {Object} urlParams
   * @param {Object} qs
   * @returns {Promise}
   */
  get(url, urlParams, qs) {
    let options = {
      method: 'GET',
      credentials: 'same-origin', // enable sending of cookies
      headers: this.headers,
    };
    if (qs) {
      options.qs = qs;
    }
    return fetch(urlTemplate(url, urlParams), options);
  }

  /**
   * @desc HTTP 'PATCH'
   * @param {String} url
   * @param {Object} urlParams
   * @param {Object} qs
   * @param {Object} payload
   * @returns {Promise}
   */
  patch(url, urlParams, qs, payload) {
    let options = {
      method: 'PATCH',
      credentials: 'same-origin', // enable sending of cookies
      body: payload,
      headers: this.headers
    };
    if (qs) {
      options.qs = qs;
    }
    return fetch(urlTemplate(url, urlParams), options);
  }

  /**
   * @desc HTTP 'POST'
   * @param {String} url
   * @param {Object} urlParams
   * @param {Object} qs
   * @param {Object} payload
   * @returns {Promise}
   */
  post(url, urlParams, qs, payload) {
    let options = {
      method: 'POST',
      credentials: 'same-origin', // enable sending of cookies
      body: payload,
      headers: this.headers
    };
    if (qs) {
      options.qs = qs;
    }
    return fetch(urlTemplate(url, urlParams), options);
  }
}
